import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure52 = { 
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height:500,
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },

      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          stacking: 'normal',
        }
      },
  
      exporting: {
        enabled: false
      },
  
  
      xAxis: [{
        categories: [ "Pacifique Nord-Est", "Pacifique Centre-Est", "Pacifique Sud-Ouest", "Pacifique Centre-Ouest", "Atlantique Nord-Est","Océan Indien oriental", "Atlantique Sud-Est","Océan Indien occidental", "Atlantique Centre-Ouest", "Atlantique Nord-Ouest", "Atlantique Centre-Est", "Pacifique Nord-Ouest", "Atlantique Sud-Ouest", "Méditerranée et mer Noire", "Pacifique Sud-Est"],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px',
          }
        },
      }],
      yAxis: [{ // Primary yAxis
        labels: {
         	format: '{value}',
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 100,
        min: 0,
        tickInterval: 10,
        format: '{value.percentage}%',
        gridLineWidth: 0,
        floor: 0,
        title: {
          text: "",
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        //headerFormat: '<div>{point.key}</div>',
        valueSuffix: '%',
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [
        {
            name: 'Non viable',
            color: '#ed7d31',
            data: [ 13.8, 14.3, 15.38, 20.4, 27.3, 34.7, 35.3, 37.5, 37.8, 38.9, 40, 45, 40, 63.3, 66.7 ]
        },
        {
            name: 'Viable',
            color: '#5b9bd5',
            data: [ 86.2, 85.7, 84.62, 79.6, 72.7, 65.3, 64.7, 62.5, 62.2, 61.1, 60, 55, 60, 36.7, 33.3 ]
        },
      ]
}
